<template>
  <div class="Crisis_addmajor_event">
    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="学生学号" prop="userId">
        <el-input :disabled="true" v-model="ruleForm.userId"></el-input>
      </el-form-item>

      <el-form-item label="学生姓名" prop="realName">
        <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
      </el-form-item>

      <el-form-item label="预警人">
        <el-input :disabled="true" v-model="ruleForm.alertName"></el-input>
      </el-form-item>

      <el-form-item label="预警人电话">
        <el-input :disabled="true" v-model="ruleForm.alertPhone"></el-input>
      </el-form-item>

      <!-- SourceFlg=3时显示紧急联系人信息 -->
      <template v-if="SourceFlg === '3' || SourceFlg === 3">
        <el-form-item label="紧急联系人">
          <el-input :disabled="true" v-model="ruleForm.urgentContact"></el-input>
        </el-form-item>

        <el-form-item label="紧急联系方式">
          <el-input :disabled="true" v-model="ruleForm.urgentContactPhone"></el-input>
        </el-form-item>

        <el-form-item label="关系">
          <el-input :disabled="true" v-model="relationText"></el-input>
        </el-form-item>
      </template>

      <el-form-item label="自杀他杀风险详情" class="nkjs">
        <el-input :disabled="true" type="textarea" v-model="ruleForm.difficultDetail"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">"五困"类型及具体表现</h2>

      <el-form-item class="difficulty" label="学习困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.studyDifficulty">
          <el-checkbox  label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox  label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox  label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox  label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox  label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox  label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox  label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox  label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:30px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -10px;" v-model="studyDifficultyOther" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.lifeDifficulty">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -40px;" v-model="lifeDifficultyOther" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="交往困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.contactDifficulty">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input v-model="contactDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: -40px;" :disabled="true"></el-input>
      </el-form-item>
            <!-- studyDifficultyOther: '',
          lifeDifficultyOther: '',
          contactDifficultyOther: '',
          developDifficultyOther: '',
          psyDifficultyOther: '', -->
      <el-form-item class="difficulty" label="发展困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.developDifficulty">
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:130px;display: block;color: #606266;">其他</span>
        <el-input v-model="developDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 90px;" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.psyDifficulty">
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:80px;display: block;color: #606266;">其他</span>
        <el-input v-model="psyDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 40px;" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item class="difficulty">
        <template slot="label">
          <span><i style="color: red"></i> 初评危机状态</span>
        </template>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="1">红色预警</el-radio>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="2">橙色预警</el-radio>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="3">黄色预警</el-radio>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="4">蓝色预警</el-radio>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="5">绿色预警</el-radio>
        <el-radio :disabled="!firstCrisisEditable" v-model="ruleForm.firstCrisis" label="6">无法确定</el-radio>
      </el-form-item>
      
      
      <!-- 审核内容输入框（按角色显示，编辑者可写，其它角色只读） -->
      <!-- 风险监控员审核内容 -->
      <el-form-item v-if="showRiskMonitorReview" label="风险监控员审核内容" class="nkjs">
        <el-input 
          type="textarea" 
          v-model="riskMonitorReviewDetail" 
          :disabled="disabledRiskMonitorReview"
          :placeholder="disabledRiskMonitorReview ? '' : '请输入风险监控员审核内容'">
        </el-input>
      </el-form-item>
      
      <!-- 危机主管审核内容 -->
      <el-form-item v-if="showCriAdminReview" label="危机主管审核内容" class="nkjs">
        <el-input 
          type="textarea" 
          v-model="criAdminReviewDetail" 
          :disabled="disabledCriAdminReview"
          :placeholder="disabledCriAdminReview ? '' : '请输入危机主管审核内容'">
        </el-input>
      </el-form-item>
      
      <!-- 中心主任审核内容 -->
      <el-form-item v-if="showCenterDirectorReview" label="中心主任审核内容" class="nkjs">
        <el-input 
          type="textarea" 
          v-model="centerDirectorReviewDetail" 
          :disabled="disabledCenterDirectorReview"
          :placeholder="disabledCenterDirectorReview ? '' : '请输入中心主任审核内容'">
        </el-input>
      </el-form-item>
      
      <!-- 办理内容输入框 -->
      <!-- type=2时：1068和1069可以看到两个输入框，但只能编辑自己的内容，另一个是查看显示 -->
      <!-- type不传值时：1068、1069、1070可以看到两个输入框，有内容就显示，没有就隐藏，都是只读 -->
      
      <!-- 危机主管办理内容 -->
      <el-form-item v-if="showCrisisAdminHandleContentDisplay" label="危机主管办理内容" class="nkjs">
        <el-input 
          type="textarea" 
          v-model="criAdminHandleDetail" 
          :disabled="!canEditCrisisAdminHandleContent"
          :placeholder="canEditCrisisAdminHandleContent ? '请输入危机主管办理内容' : ''" >
        </el-input>
      </el-form-item>
      
      <!-- 风险监控员办理内容 -->
      <el-form-item v-if="showRiskMonitorHandleContentDisplay" label="风险监控员办理内容" class="nkjs">
        <el-input 
          type="textarea" 
          v-model="riskMonitorHandleDetail" 
          :disabled="!canEditRiskMonitorHandleContent"
          :placeholder="canEditRiskMonitorHandleContent ? '请输入风险监控员办理内容' : ''" >
        </el-input>
      </el-form-item>
      
      <!-- 办理提交按钮（type=2时显示） -->
      <div v-if="showHandleSubmitBtn" style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
        <el-button type="primary" @click="handleHandleSubmit()">确认</el-button>
      </div>
      
      <!-- 按钮区域 -->
      <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
        <!-- 1063: 只显示提交按钮 -->
        <el-button v-if="showSubmitBtn" type="primary" @click="handleSubmit('1')">提交</el-button>
        
        <!-- 1069、1068、1070: 显示提交和驳回按钮 -->
        <template v-if="showSubmitAndRejectBtns">
          <!-- 1068 + 初评「无法确定」：仅驳回 + 提交咨询主管 -->
          <template v-if="showCrisisAdminConsultDirectorBtns">
            <el-button type="danger" @click="handleReject">驳回</el-button>
            <el-button type="primary" @click="handleSubmit('4')" style="margin-left: 30px;">提交咨询主管</el-button>
          </template>
          <template v-else>
            <el-button type="danger" @click="handleReject">驳回</el-button>
            <el-button type="primary" @click="handleSubmit('1')" style="margin-left: 30px;">{{ auditPrimarySubmitText }}</el-button>
          </template>
        </template>
      
        <!-- 1068: 显示审核确认（初评非「无法确定」时） -->
        <el-button v-if="showFinalSubmitBtn" type="success" @click="handleSubmit('2')" style="margin-left: 30px;">审核确认</el-button>
      </div>

      
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      roleID:'',
      KeyNo: '',
      pdtcbx: true,
      pdtcbx2: true,
      pdtcbx9: true,//是否在心理中心咨询
      radio: '1',
      firstCrisisEditable: false, // 控制firstCrisis是否可编辑，默认不可编辑
      type:'',
      SourceFlg: '', // 来源标识
      relationDict: [], // 关系字典数据
      criAdminHandleDetail: '', // 危机主管办理内容（1068）
      riskMonitorHandleDetail: '', // 风险监控员办理内容（1069）
      // 审核内容（type=1）
      riskMonitorReviewDetail: '', // 风险监控员审核内容（1069）
      criAdminReviewDetail: '', // 危机主管审核内容（1068）
      centerDirectorReviewDetail: '', // 中心主任审核内容（1070）
      lifeDifficultyOther: '',
      studyDifficultyOther: '',
      contactDifficultyOther: '',
      developDifficultyOther: '',
      psyDifficultyOther: '',
      ruleForm: {
        difficultDetail: '',//严重心理困扰表现
        alertName: '',//预警人
        alertPhone: '',//预警人电话
        urgentContact: '',//紧急联系人
        urgentContactPhone: '',//紧急联系方式
        relation: '',//关系
        userId: '',//学生学号
        realName: '',//学生姓名
        firstCrisis: '',//初评危机状态
        studyDifficulty: [],//学生困难
        lifeDifficulty: [],//生活困难
        contactDifficulty: [],//交往困难 
        developDifficulty: [],//发展困难
        psyDifficulty: [],//心理困难
        discovery: [],//发展途径
      },
      rules: {
        userId: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        psychCentralSuggest: [
          { type: 'array', required: true, message: '请至少选择一个心理中心建议', trigger: 'change' }
        ],
      }
    };
  },
  computed: {
    // 判断是否显示提交按钮（1063显示）
    showSubmitBtn() {
      return this.roleID && this.roleID.indexOf('1063') !== -1 && this.type === '1';
    },
    // 判断是否显示提交和驳回按钮（1069、1068、1070显示）
    showSubmitAndRejectBtns() {
      if (this.type !== '1') return false;
      const roles = ['1069', '1068', '1070'];
      return roles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
    },
    // 1068 + 审核 + 初评「无法确定」：走驳回/提交咨询主管，不显示审核确认
    showCrisisAdminConsultDirectorBtns() {
      return (
        this.type === '1' &&
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.ruleForm.firstCrisis === '6'
      );
    },
    // 判断是否显示审核确认按钮（1068 显示，初评为无法确定时不显示）
    showFinalSubmitBtn() {
      return (
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.type === '1' &&
        this.ruleForm.firstCrisis !== '6'
      );
    },
    // 审核(type=1)主提交按钮文案：1069=提交危机主管；1068=提交中心主任；默认=审核确认
    auditPrimarySubmitText() {
      if (!this.roleID) return '审核确认';
      if (this.roleID.indexOf('1069') !== -1) return '提交危机主管';
      if (this.roleID.indexOf('1068') !== -1) return '提交中心主任';
      return '审核确认';
    },
    // 判断是否显示危机主管办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showCrisisAdminHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.criAdminHandleDetail && this.criAdminHandleDetail.trim();
      }
      return false;
    },
    // 判断是否显示风险监控员办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showRiskMonitorHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.riskMonitorHandleDetail && this.riskMonitorHandleDetail.trim();
      }
      return false;
    },
    // 判断是否可以编辑危机主管办理内容（type=2时，只有1068可以编辑）
    canEditCrisisAdminHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1068') !== -1;
    },
    // 判断是否可以编辑风险监控员办理内容（type=2时，只有1069可以编辑）
    canEditRiskMonitorHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1069') !== -1;
    },
    // 判断是否显示办理提交按钮（type=2时，1068或1069显示）
    showHandleSubmitBtn() {
      if (this.type !== '2') return false;
      return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
             (this.roleID && this.roleID.indexOf('1069') !== -1);
    },
    // 审核与查看场景下三类审核内容的显示与禁用控制
    showRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1069') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1068') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1070') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    // 根据relation值获取对应的文本
    relationText() {
      if (!this.ruleForm.relation || !this.relationDict || this.relationDict.length === 0) {
        return '';
      }
      const relationItem = this.relationDict.find(item => item.dicKey === this.ruleForm.relation);
      return relationItem ? relationItem.cDicValue : this.ruleForm.relation;
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 驳回处理（带确认提示）
    handleReject() {
      this.$confirm('确认驳回该申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSubmit('0');
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 提交/驳回处理
    handleSubmit(type) {
      // type: '0' 驳回, '1' 提交（按角色对应主流程）, '2' 审核确认(1068), '4' 提交咨询主管(1068+无法确定)
      // 验证 keyNo
      if (!this.KeyNo || !this.KeyNo[0]) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.KeyNo[0],
        type: type, // 提交驳回标记
      };
      
      // 根据角色决定是否传初评危机状态
      const editableRoles = ['1063', '1069', '1068', '1070'];
      const canEdit = editableRoles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
      
      if (canEdit) {
        // 1063、1069、1068 传初评危机状态
        if (!this.ruleForm.firstCrisis||this.ruleForm.firstCrisis=='0') {
          this.$message.warning('请选择初评危机状态');
          return;
        }
        params.firstCrisis = this.ruleForm.firstCrisis;
      }
      
      // 审核(type=1)时附带对应角色的审核内容（若填写）
      if (this.type === '1') {
        if (this.roleID && this.roleID.indexOf('1069') !== -1 && this.riskMonitorReviewDetail && this.riskMonitorReviewDetail.trim()) {
          params.RiskMonitorReviewDetail = this.riskMonitorReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1068') !== -1 && this.criAdminReviewDetail && this.criAdminReviewDetail.trim()) {
          params.CriAdminReviewDetail = this.criAdminReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1070') !== -1 && this.centerDirectorReviewDetail && this.centerDirectorReviewDetail.trim()) {
          params.CenterDirectorReviewDetail = this.centerDirectorReviewDetail.trim();
        }
      }
      
      this.$Http_Post('/DistressPrediction/UpdateFirstCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '操作成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '操作失败');
        }
      }).catch((err) => {
        this.$message.error('操作失败');
      });
    },
    // 办理提交处理（type=2时使用）
    handleHandleSubmit() {
      // 验证 keyNo
      if (!this.KeyNo || !this.KeyNo[0]) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.KeyNo[0],
        type: '2', // 办理标记
      };
      
      // 根据角色添加不同的办理内容字段
      if (this.roleID && this.roleID.indexOf('1068') !== -1) {
        // 1068: 危机主管办理内容
        if (!this.criAdminHandleDetail || !this.criAdminHandleDetail.trim()) {
          this.$message.warning('请输入危机主管办理内容');
          return;
        }
        params.criAdminHandleDetail = this.criAdminHandleDetail.trim();
      } else if (this.roleID && this.roleID.indexOf('1069') !== -1) {
        // 1069: 风险监控员办理内容
        if (!this.riskMonitorHandleDetail || !this.riskMonitorHandleDetail.trim()) {
          this.$message.warning('请输入风险监控员办理内容');
          return;
        }
        params.riskMonitorHandleDetail = this.riskMonitorHandleDetail.trim();
      }
      
      this.$Http_Post('/DistressPrediction/HandleCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '办理提交成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '办理提交失败');
        }
      }).catch((err) => {
        this.$message.error('办理提交失败');
      });
    },
  },
  mounted() {
    this.roleID = sessionStorage.getItem("RoleID");
    this.KeyNo = [this.$route.query.KeyNo];
    // 从路由参数获取是否可编辑
    this.type = this.$route.query.type;
    // 审核(type=1)时：1063、1069、1068、1070 可编辑
    const editableRoleIDs = ['1063', '1069', '1068', '1070'];
    const hasEditableRole = editableRoleIDs.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
    this.firstCrisisEditable = this.type === '1' && hasEditableRole;
    
    // 获取关系字典数据
    this.$Http_Post('/User/GetDictionaryList', { DicTypCode: '19' }).then((res) => {
      if (res.Code == 0 || res.Code == 200) {
        this.relationDict = res.Data || [];
      }
    }).catch((err) => {
      console.error('获取关系字典失败', err);
    });
    
    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.KeyNo[0] }).then((res) => {
      if (res.Code == 0) {
        this.ruleForm.userId = res.Data.userId;
        this.ruleForm.realName = res.Data.realName;
        this.ruleForm.alertName = res.Data.alertName;
        this.ruleForm.alertPhone = res.Data.alertPhone;
        this.ruleForm.difficultDetail = res.Data.difficultDetail;
        this.ruleForm.firstCrisis = res.Data.firstCrisis || '';
        // 获取SourceFlg和紧急联系人信息
        if (res.Data.SourceFlg !== undefined) {
          this.SourceFlg = res.Data.SourceFlg;
        }
        if (res.Data.urgentContact !== undefined) {
          this.ruleForm.urgentContact = res.Data.urgentContact || '';
        }
        if (res.Data.urgentContactPhone !== undefined) {
          this.ruleForm.urgentContactPhone = res.Data.urgentContactPhone || '';
        }
        if (res.Data.relation !== undefined) {
          this.ruleForm.relation = res.Data.relation || '';
        }
        // 获取办理内容（如果接口返回了这些字段）
        if (res.Data.CriAdminHandleDetail !== undefined) {
          this.criAdminHandleDetail = res.Data.CriAdminHandleDetail || '';
        }
        if (res.Data.RiskMonitorHandleDetail !== undefined) {
          this.riskMonitorHandleDetail = res.Data.RiskMonitorHandleDetail || '';
        }
        // 回显审核内容（若接口返回）
        if (res.Data.RiskMonitorReviewDetail !== undefined) {
          this.riskMonitorReviewDetail = res.Data.RiskMonitorReviewDetail || '';
        }
        if (res.Data.CriAdminReviewDetail !== undefined) {
          this.criAdminReviewDetail = res.Data.CriAdminReviewDetail || '';
        }
        if (res.Data.CenterDirectorReviewDetail !== undefined) {
          this.centerDirectorReviewDetail = res.Data.CenterDirectorReviewDetail || '';
        }
        for (let i = 0; i <= res.Data.studyDifficultys.length; i++) {
            this.studyDifficultyOther = res.Data.studyDifficultyOther;
            this.ruleForm.studyDifficulty = res.Data.studyDifficultys;
        }
        for (let i = 0; i <= res.Data.lifeDifficultys.length; i++) {
 
            this.lifeDifficultyOther = res.Data.lifeDifficultyOther;
            this.ruleForm.lifeDifficulty = res.Data.lifeDifficultys;

        }
        for (let i = 0; i <= res.Data.contactDifficultys.length; i++) {

            this.contactDifficultyOther = res.Data.contactDifficultyOther;
            this.ruleForm.contactDifficulty = res.Data.contactDifficultys;

        }
        for (let i = 0; i <= res.Data.developDifficultys.length; i++) {
            this.developDifficultyOther = res.Data.developDifficultyOther;
            this.ruleForm.developDifficulty = res.Data.developDifficultys;

        }
        for (let i = 0; i <= res.Data.psyDifficultys.length; i++) {
            this.psyDifficultyOther = res.Data.psyDifficultyOther;
            this.ruleForm.psyDifficulty = res.Data.psyDifficultys;
        }
      }
    });
  }
}
</script>

<style>
  .Crisis_addmajor_event{width: 100%;background-color: rgb(255, 255, 255);min-height: 100%;}
  .Crisis_addmajor_event .el-form {
    padding-bottom: 40px;
  }
  .Crisis_addmajor_event .el-input{width: 240px;}
  .Crisis_addmajor_event .quz .el-form-item__content{margin-left: 20px !important;}
  .Crisis_addmajor_event .bgfbf .el-form-item__label{width: 150px !important;}
  .Crisis_addmajor_event .hjoi .el-form-item__label{width: 180px !important;}
  .Crisis_addmajor_event .bgssfbf .el-form-item__label{width: 492px !important;}
  .Crisis_addmajor_event .huhxs .el-form-item__label{width: 172px !important;}
  .Crisis_addmajor_event .huhxsxs .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .suicidalFlg .el-form-item__label{width: 210px !important;}
  .Crisis_addmajor_event .psychosesFlg  .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .InjuryDetails  .el-form-item__label{width: 275px !important;}
  .Crisis_addmajor_event .InjuryDetails  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p1 .el-form-item__label{width: 170px !important;}
  .Crisis_addmajor_event .p2 .el-form-item__label{width: 130px !important;}
  .Crisis_addmajor_event .p3 .el-form-item__label{width: 142px !important;}
  .Crisis_addmajor_event .p4 .el-form-item__label{width: 156px !important;}
  .Crisis_addmajor_event .p5 .el-form-item__label{width: 200px !important;}
  .Crisis_addmajor_event .p5  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p6 .el-form-item__label{width: 186px !important;}
  .Crisis_addmajor_event .p6  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p7 .el-form-item__label{width: 176px !important;}

  .Crisis_addmajor_event .difficulty{width: 1400px !important;}

  .Crisis_addmajor_event .nkjs .el-textarea.is-disabled .el-textarea__inner{width: 500px !important;height: 80px;}
  .Crisis_addmajor_event .nkjs .el-textarea .el-textarea__inner{width: 500px !important;height: 80px;}
</style>